import * as React from "react";
import { InputBase, styled } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { commonBoxShadowStyle } from "fe-common/ui/boxShadow";
import clsx from "clsx";

//region [[ Styles ]]

const FilterSettingsSearchBoxView = styled(InputBase)({
  background: "white",
  borderRadius: "14px",
  // border: "1px solid #232323",
  padding: "5px",
  ...commonBoxShadowStyle,
  marginRight: "auto",
  "& input": {
    padding: "0 2px",
    width: "90px",
    transition: "0.3s ease-out",
  },
  "& input:focus, &.active input": {
    width: "300px",
  },
});

const Icon = styled(SearchIcon)({
  fill: "#9E9E9E",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface FilterSettingsSearchBoxProps {
  className?: string;
  value: string;
  onValueChanged: (newValue: string) => void;
  placeholder?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const FilterSettingsSearchBox = ({
  ...props
}: FilterSettingsSearchBoxProps) => {
  const handleValueChanged = (e) => {
    props.onValueChanged?.(e.target.value);
  };

  return (
    <FilterSettingsSearchBoxView
      className={clsx(
        props.className,
        props.value && props.value !== "" ? "active" : "",
      )}
      value={props.value}
      onChange={handleValueChanged}
      startAdornment={<Icon />}
      endAdornment={props.value?.length > 0?<CloseIcon style={{cursor:'pointer'}} onClick={()=>props.onValueChanged?.("")}/>:null}
      placeholder={props.placeholder || "Search"}
    />
  );
};
